import React, { useState, useEffect } from "react";
import "@/App.css";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Products } from "@/components/landing/Products";
import { Benefits } from "@/components/landing/Benefits";
import { About } from "@/components/landing/About";
import { Testimonials } from "@/components/landing/Testimonials";
import { Footer } from "@/components/landing/Footer";
import { Toaster } from "@/components/ui/sonner";
import { LandingDataProvider } from "@/context/LandingDataContext";
import { AdminPanel } from "@/components/admin/AdminPanel";

function AppContent() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener("popstate", handleLocationChange);
    return () => window.removeEventListener("popstate", handleLocationChange);
  }, []);

  if (currentPath === "/panel") {
    return (
      <div className="App" data-testid="admin-panel-page">
        <AdminPanel />
        <Toaster />
      </div>
    );
  }

  return (
    <div className="App" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Products />
        <Benefits />
        <About />
        <Testimonials />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <LandingDataProvider>
      <AppContent />
    </LandingDataProvider>
  );
}

export default App;
